import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import React from 'react'
import { browserHistory } from 'react-router'
import dummyBg from '../../assets/img/DummyBg.png'
import { eraseGlobalCookie, getLocalStorageInfo } from '../../utils'
import { trackLogOut } from '../../utils/mixpanel'

const ENV_LABELS = {
  dev: 'Development',
  qa: 'Staging (QA)',
  'uat-api': 'UAT',
  api: 'Production',
}

export default function OtherInstanceModal({ currentEnv }) {
  const envLabel = ENV_LABELS[currentEnv] || currentEnv

  const onLogoutAll = () => {
    trackLogOut(getLocalStorageInfo())
    localStorage.clear();
    eraseGlobalCookie('lessorAccess')
    eraseGlobalCookie('redirectURI')
    eraseGlobalCookie('domain')
    eraseGlobalCookie('userName')
    eraseGlobalCookie('hasMultilLessorAccess')
    browserHistory.push('/login');
  }

  return (
    <div
      style={{
        backgroundImage: `url(${dummyBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
        height: '100vh',
        filter: 'blur(4px)',
      }}
    >
      <Dialog
        open={true}
        className='console-management-modal'
        maxWidth="md"
      >
        <DialogTitle id="scroll-dialog-title">
          Another Session is Active
        </DialogTitle>
        <DialogContent dividers>
          <p>
            You're already logged in to the <strong>{envLabel}</strong> environment in this browser.
          </p>
          <p>
            To avoid conflicts, only one Sparta environment can be active per browser at a time.
            Please log out of the {envLabel} session before continuing here, or switch back to that tab to keep working.
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={onLogoutAll} color="primary" variant="contained">
            Logout from All Instances
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
